/**
 * Преобразует массив цветов в объект с hex значениями
 * @param {Array} colorsArray - Массив объектов [{name: 'Color 1', hex: '#fff', id: '...'}, ...]
 * @returns {Object} Объект {color1: '#fff', color2: '#000', color3: '#ccc'}
 */
export function mapColorsToHexObject(colorsArray) {
  if (!Array.isArray(colorsArray)) {
    return { color1: '', color2: '', color3: '' };
  }

  const colors = { color1: '', color2: '', color3: '' };

  colorsArray.forEach((colorObj) => {
    if (colorObj.name === 'Color 1') colors.color1 = colorObj.hex;
    if (colorObj.name === 'Color 2') colors.color2 = colorObj.hex;
    if (colorObj.name === 'Color 3') colors.color3 = colorObj.hex;
  });

  return colors;
}

/**
 * Преобразует массив цветов в объект с полными данными (hex + id)
 * @param {Array} colorsArray - Массив объектов цветов
 * @returns {Object} Объект {color1: {hex, id}, color2: {hex, id}, color3: {hex, id}}
 */
export function mapColorsToFullObject(colorsArray) {
  if (!Array.isArray(colorsArray)) {
    return {
      color1: { hex: '', id: null },
      color2: { hex: '', id: null },
      color3: { hex: '', id: null },
    };
  }

  const colorMap = {
    color1: { hex: '', id: null },
    color2: { hex: '', id: null },
    color3: { hex: '', id: null },
  };

  colorsArray.forEach((c) => {
    if (c.name === 'Color 1') colorMap.color1 = { hex: c.hex, id: c.id };
    if (c.name === 'Color 2') colorMap.color2 = { hex: c.hex, id: c.id };
    if (c.name === 'Color 3') colorMap.color3 = { hex: c.hex, id: c.id };
  });

  return colorMap;
}
